import classnames from 'classnames';

import Image from 'components/Image';
import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { IAppState } from 'types/app';
import { ICard } from 'types/cards';

import getBorderColour from 'utils/getBorderColour';

import makeTooltipData from '../../utils/makeTooltipData';

function Card(props: Props & ReturnType<typeof mapStateToProps> & RouteComponentProps) {
  const { data, isFetching, onClick } = props;

  const borderColour = getBorderColour(data);
  const tooltipData = makeTooltipData({
    data,
    action: onClick,
  });

  return (
    <div
      className={classnames(
        'hand__card',
        isFetching && 'card--fetching',
      )}
    >
      <Image
        borderContainerClassName="hand__border"
        className="hand__image"
        icon={data.image}
        alt={data.name}
        onClick={onClick}
        border={borderColour}
        tooltipData={tooltipData}
      />
    </div>
  );
}

interface Props {
  data: ICard,
  onClick: () => void,
}

const mapStateToProps = ({ cards: { isFetching } }: IAppState) => ({ isFetching });

export default withRouter(connect(mapStateToProps)(Card));